import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { Injectable } from '@angular/core';
import { INavData } from '@coreui/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from '../models/enums.model';
import { AtecoCompanyType } from '../models/company.model';

@Injectable({ providedIn: 'root' })

export class MenuService {

  globalService = GlobalService;
  companytypeenum = AtecoCompanyType;
  
  constructor(private translate: TranslateService, private authService: AuthService) { }


  /**
   * Popolo l'array NavItems con i parametri passati in ingresso
   */
  setMenu() {

    // let menu: Array<INavData> = new Array<INavData>();
    this.globalService.navItems = new Array<INavData>();

    this.globalService.navItems.push({
      name: this.translate.instant("MENU.DASHBOARD"),
      url: '/dashboard',
      icon: 'fa fa-home',
      class: 'dashboard'
    });

    if (this.globalService.currentManagedCompany != null) {

      this.globalService.navItems.push({
        name: this.translate.instant("MENU.AMMINISTRATION"),
        url: ' ',
        icon: 'fa fa-folder-open',
        class: 'registry',
        children: [
          {
            name: this.translate.instant("MENU.REGISTRY.COMPANIES"),
            url: '/registry/list-companies',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.USERS"),
            url: '/registry/list-users',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.LICENSES"),
            url: '/manage-licenses',
            class: 'licenses'
          }
        ]
      })
    } else {

      this.globalService.navItems.push({
        name: this.translate.instant("MENU.REGISTRY.MAIN"),
        url: ' ',
        icon: 'fa fa-folder-open',
        class: 'registry',
        children: [
          // {
          //   name: this.translate.instant("MENU.REGISTRY.COMPANIES"),
          //   url: '/registry/list-companies',
          //   icon: ''
          // },
          {
            name: this.translate.instant("MENU.REGISTRY.CUSTOMERS"),
            url: '/registry/list-customers/C',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.SUPPLIERS"),
            url: '/registry/list-customers/F',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.VATRATES"),
            url: '/registry/list-VATRates',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.PRODUCTS"),
            url: '/registry/list-products',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.PAYMENT_CONDITIONS"),
            url: '/registry/list-payment-conditions',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.REGISTRY.DOCUMENT_NOTES"),
            url: '/registry/list-document-notes',
            icon: ''
          },          
          {
            name: this.translate.instant("MENU.REGISTRY.DOCUMENT_PROFILES"),
            url: '/registry/list-documentprofiles',
            icon: ''
          }
          // {
          //   name: this.translate.instant("MENU.REGISTRY.USERS"),
          //   url: '/registry/list-users',
          //   icon: ''
          // }
        ]
      });
        
      this.globalService.navItems.push({
        name: this.translate.instant("MENU.DOCUMENT.MAIN"),
        url: ' ',
        icon: 'fa fa-file-text',
        class: 'document',
        children: [
          {
            name: this.translate.instant("MENU.DOCUMENT.DOCUMENTS"),
            url: '/document/list-documents',
            icon: ''
          },
          { 
            name: this.translate.instant("MENU.DOCUMENT.PASSIVE_INVOICES"),
            url: '/document/list-passive-documents',
            icon: ''
          },
          /*       FatturePLUSFrancia *****   
          { 
            ...GlobalService.getCurrentCompany() != null && 
               GlobalService.CompanyTypeFromAteco(GlobalService.getCurrentCompany().CodiceAteco) != this.companytypeenum.STUDILEGALI  &&
               GlobalService.getCurrentCompany().TipoSoggetto != 1 ?
            {                         
              name: this.translate.instant("MENU.BILLING_PLUS.ACTIVE_CYCLE"),
              url: '/billing-plus/active-cycle',
              icon: ''                           
            }: {}
          },
          {       
            ...GlobalService.getCurrentCompany() != null && 
               GlobalService.CompanyTypeFromAteco(GlobalService.getCurrentCompany().CodiceAteco) != this.companytypeenum.STUDILEGALI &&
               GlobalService.getCurrentCompany().TipoSoggetto != 1 ?
            {     
              name: this.translate.instant("MENU.BILLING_PLUS.PASSIVE_CYCLE"),
              url: '/billing-plus/passive-cycle',
              icon: ''                                  
            }: {}
          },
          {
            name: this.translate.instant("MENU.DOCUMENT.BOLLI"),
            url: '/document/list-bolli/'+ new Date().getFullYear() + '/' + Math.ceil((new Date().getMonth() + 1)/ 3),
            icon: ''
          },
          {
            name: this.translate.instant("MENU.DOCUMENT.RF19CONTROL"),
            url: 'rf19-summary',            
            icon: ''            
          },
          //Lo sviluppo della sezione è previsto per Settembre
          // {
          //   name: this.translate.instant("MENU.BILLING_PLUS.CASH_FLOW_AND_ACCOUNTING_ENTRIES"),
          //   url: '/billing-plus/cash-flow',
          //   icon: ''
          // },*/
        ]
      });
      this.globalService.navItems.push({
        name: this.translate.instant("MENU.SCHEDULER.MAIN"),
        url: ' ',
        icon: 'fa fa-calendar-check-o',
        class: 'scheduler',
        children: [
          {
            name: this.translate.instant("MENU.SCHEDULER.SCHEDULER_ACTIVE"),
            url: '/scheduler/list-active-scheduler',
            icon: ''
          },
          {
            name: this.translate.instant("MENU.SCHEDULER.SCHEDULER_PASSIVE"),
            url: '/scheduler/list-passive-scheduler',
            icon: ''
          }
        ]
      });
       
      // Da ripristinare appena lavoreremo sull'invio asincrono
      // if(this.authService.getCurrentUser() != null 
      //  && this.authService.getCurrentUser().Role == UserRole.Admin
      // && GlobalService.getCurrentCompany() != null && 
      //     GlobalService.CompanyTypeFromAteco(GlobalService.getCurrentCompany().CodiceAteco) != this.companytypeenum.STUDILEGALI  &&
      //    GlobalService.getCurrentCompany().TipoSoggetto == 1         
      //   ) {
      //     this.globalService.navItems.push({
      //       name: this.translate.instant("MENU.SCHEDULER.STS_SCHEDULER"),
      //       url: '/scheduler/list-sts-scheduler',
      //       icon: 'fa fa-cloud-upload'
      //   })
      // }
        

      if (this.authService.getCurrentUser() != null && (this.authService.getCurrentUser().FK_Company == GlobalService.getUsedCompany())) {
        this.globalService.navItems.push({
          name: this.translate.instant("MENU.AUTHORIZATIONS"),
          icon: 'fa fa-key',
          url: 'manage-authorizations',
          class: 'authorizations'
        });        
        this.globalService.navItems.push({
          name: this.translate.instant("MENU.AMMINISTRATION"),
          url: ' ',
          icon: 'fa fa-folder-open',
          class: 'registry',
          children: [
            {
              name: this.translate.instant("MENU.REGISTRY.COMPANIES"),
              url: '/registry/list-companies',
              icon: ''
            },
            {
              name: this.translate.instant("MENU.REGISTRY.USERS"),
              url: '/registry/list-users',
              icon: ''
            },
            {
              name: this.translate.instant("MENU.REGISTRY.EMAIL_TEMPLATES"),
              url: '/registry/list-email-templates',
              icon: ''
            },
            {
              name: this.translate.instant("MENU.LICENSES"),
              url: '/manage-licenses',
              class: 'licenses'
            },
            {
              ...GlobalService.getUsedCompany() == 3 ?
                {
                  name: this.translate.instant("MENU.COMPANY_REPORTS"),
                  url: 'company-reports',
                  icon: ''
                }
                : {}
            },
            {
              ...GlobalService.getUsedCompany() == 3 ?
                {
                  name: this.translate.instant("MENU.NOTIFICATION_MANAGEMENT"),
                  url: 'list-notification',
                  icon: ''
                }
                : {}
            }
          ]
        })
      }

      if(this.authService.getCurrentUser() != null && this.authService.getCurrentUser().Role == UserRole.Admin) {
        this.globalService.navItems.push({
            name: this.translate.instant("MENU.STATISTICS"),
            url: 'statistics',
            icon: 'fa fa-calculator'
        })
      }

    }

  }


  
}
